/* src/app/components/submission-device-characteristics-eu/submission-device-characteristics-eu.component.css */
/*# sourceMappingURL=submission-device-characteristics-eu.component.css.map */
